import { createContext, useContext } from "react";
import { formatCurrency as _formatCurrency } from "@/lib/calculations";

export const CURRENCIES = [
  { code: "USD", label: "US Dollar",            symbol: "$" },
  { code: "CAD", label: "Canadian Dollar",      symbol: "$" },
  { code: "GBP", label: "British Pound",        symbol: "£" },
  { code: "EUR", label: "Euro",                 symbol: "€" },
  { code: "AUD", label: "Australian Dollar",    symbol: "$" },
  { code: "NZD", label: "New Zealand Dollar",   symbol: "$" },
  { code: "ZAR", label: "South African Rand",   symbol: "R" },
];

const CurrencyContext = createContext("USD");

export function CurrencyProvider({ currency, children }) {
  return (
    <CurrencyContext.Provider value={currency || "USD"}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}

export function useFormatCurrency() {
  const currency = useContext(CurrencyContext);
  return (n) => _formatCurrency(n, currency);
}
